<div class="catalog-dialog">
  <div mat-dialog-content class="catalog-dialog-content">
    <div class="title">Purchase Fake Entitlements</div>

    <div class="form">
      <form [formGroup]="formgroup" class="form-group">
        <div>
          <ra-ui-search-input
            [formControl]="searchText"
            label="Search"
            name="searchText"
            [config]="{ hideItemCounts: true }"
          >
          </ra-ui-search-input>
        </div>

        <!-- Used Angular Material Date picker instead on WTUI bcos previous date are not disabled in WTUI DatePicker -->
        <div class="input-container">
          <mat-form-field class="effective-date-picker">
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Effective Date"
              [min]="startDate"
              [formControl]="effectiveDate"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <ra-ui-spinner-input
            #qtyInput
            [config]="{
              min: 1,
              max: 1000,
              stepValue: 1,
              loopValue: true,
              displayType: integerDisplayType,
            }"
            label="Quantity"
            [formControl]="quantity"
            [errorMessages]="errorMessages(1, 1000)"
            hintMessageStart="default for credits is 1000"
            >1
          </ra-ui-spinner-input>

          <ra-ui-spinner-input
            [config]="{
              min: 1,
              max: 365,
              stepValue: 1,
              loopValue: true,
              displayType: integerDisplayType,
            }"
            label="Duration (Days)"
            [formControl]="duration"
            [errorMessages]="errorMessages(1, 365)"
          ></ra-ui-spinner-input>
        </div>
        <mat-selection-list #catSelection (selectionChange)="selectionChange($event.options)">
          @for (catalogItem of search$ | async; track catalogItem.catalogCode) {
            <mat-list-option
              class="catalog-item"
              [checkboxPosition]="'before'"
              [value]="catalogItem"
              [selected]="selectedCodes.value && selectedCodes.value.indexOf(catalogItem) >= 0"
            >
              <p class="body-2-bold entitlement-title" matline>{{ catalogItem.name }}</p>
              <span class="body-2" matline>{{ catalogItem.appName }} | Catalog: {{ catalogItem.catalogCode }} </span>
            </mat-list-option>
          }
        </mat-selection-list>
      </form>
    </div>
  </div>
  <div class="btn-container">
    <ra-ui-main-button
      class="margin-12"
      label="Add {{ selectedCodes.value?.length }} entitlements"
      (click)="addEntitlements()"
      [disabled]="formgroup.valid === false"
    >
    </ra-ui-main-button>
    <ra-ui-outlined-button label="Cancel" (click)="cancel()"></ra-ui-outlined-button>
  </div>
</div>
